var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.images && _vm.images.length
    ? _c(
        "el-carousel",
        {
          staticClass: "text-center",
          attrs: { trigger: "click", "indicator-position": "outside" }
        },
        _vm._l(_vm.images, function(image, index) {
          return _c("el-carousel-item", { key: index }, [
            _c("a", { attrs: { href: image.url, target: "_blank" } }, [
              _c("img", {
                attrs: { src: image.url, alt: image.name, height: "300px" }
              })
            ])
          ])
        })
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f0023e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f0023e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/shared/file/image-carousel.vue
// module id = null
// module chunks = 